/**
 * Util to check if url requested is authorized to be prefixed with "Archive""
 * This prefix will be deleted in next version API.
 * To delete at this moment.
 */
export class ArchiveUtil {
  static isAuthorized(method: string, url: string): boolean {
    return (
      ARCHIVE_AUTHORIZED.findIndex(
        (a) =>
          a.methods.includes(method as HTTP_METHOD) &&
          (a.url.toLocaleLowerCase() === url.toLocaleLowerCase() ||
            this.testUrlMatch(url)),
      ) >= 0
    );
  }

  static testUrlMatch(urlToTest: string): boolean {
    const urlSplitted = urlToTest
      .toLocaleLowerCase()
      .split('/')
      .filter((a) => a.length > 0);

    return URL_AUTHORIZED_SPLITTED.some((ua) => {
      if (ua.length === urlSplitted.length) {
        return urlSplitted.every(
          (fragment, index) => fragment === ua[index] || ua[index] === '{}',
        );
      }
      return false;
    });
  }
}

const enum HTTP_METHOD {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
}

const ARCHIVE_AUTHORIZED = [
  {
    url: '/Balance/Generale/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Balance/Generale/CycleComptable/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Balance/Client/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Balance/Fournisseur/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Balance/Client/Date',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Balance/Fournisseur/Date',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Balance/Generale/Date',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Balance/Generale/Date/CycleComptable/{}',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Revision/{}/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Compte/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Compte/Search/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Compte',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Compte',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Compte/{}',
    methods: [HTTP_METHOD.PUT],
  },
  {
    url: '/Centralisateur',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Centralisateur/Desequilibre',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Ecriture',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Ecriture/Search/{}/{}',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Ecriture/Rapprochement',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Ecriture/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Ecriture/Saisie',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Journal',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Journal',
    methods: [HTTP_METHOD.POST],
  },
  {
    url: '/Journal/Sourced',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Journal/Dossier/Search/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/RapprochementBancaire',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/RapprochementBancaire/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/RapprochementBancaire/Ecriture/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Intercalaire/{}',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/TableCloture',
    methods: [HTTP_METHOD.GET],
  },
  {
    url: '/Export/Fec',
    methods: [HTTP_METHOD.POST],
  },
];

const URL_AUTHORIZED_SPLITTED = ARCHIVE_AUTHORIZED.map((a) =>
  a.url
    .toLocaleLowerCase()
    .split('/')
    .filter((a) => a.length > 0),
);
